import React from 'react';
import PlaylistsTable from './compnents/playlists-table/playlists-table';

const Playlists: React.FC = () => {
  return (
    <div className="w-full h-full">
      <PlaylistsTable />
    </div>
  );
};

export default Playlists;
